
import {
  defineComponent,
  onMounted,
  onBeforeUnmount, reactive, computed, ref,
} from 'vue';
import SectionSpacerClouds from '@/components/partials/SectionSpacerClouds.vue';

export default defineComponent({
  components: {
    SectionSpacerClouds,
  },

  setup() {
    const clouds = ref<InstanceType<typeof SectionSpacerClouds>>();
    const header = reactive({
      $el: null as null | HTMLElement,
    });
    const footer = reactive({
      $el: null as null | HTMLElement,
    });
    const minHeight = reactive({ value: null as number | null });
    const minHeightPx = computed(() => (minHeight.value ? `min-height:${minHeight.value}px` : null));

    const setMinHeight = () => {
      minHeight.value = window.innerHeight;

      if (header.$el) {
        minHeight.value -= header.$el.offsetHeight;
      }

      if (clouds.value && clouds.value.$el) {
        minHeight.value -= clouds.value.$el.scrollHeight;
        minHeight.value += window.innerWidth * 0.0515;
      }

      if (footer.$el) {
        minHeight.value -= footer.$el.scrollHeight;
      }
    };

    onMounted(() => {
      header.$el = document.querySelector('header');
      footer.$el = document.querySelector('footer');
      window.addEventListener('resize', setMinHeight);
      window.addEventListener('load', setMinHeight);
      setMinHeight();
      for (let i = 100; i < 1000; i += 100) {
        setTimeout(setMinHeight, i);
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setMinHeight);
      window.removeEventListener('load', setMinHeight);
    });

    return {
      minHeight,
      minHeightPx,
      clouds,
    };
  },
});
